// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ZaTU","controls":"styles_controls__2c_MZ","charLimit":"styles_charLimit__1B7LT","input":"styles_input__2z4gR","send":"styles_send__3AS_t"};